import type { FaireProductEntity } from "../../entity_types/product";

export const sweet_wink_2: FaireProductEntity = {
  token: "sweet-wink-2",
  type: "product",
  name: "Mardi Gras Short Sleeve Tutu Bodysuit - Baby Clothing",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/cab7385d053843f25aaf0d4228fe8a9e612f3b4b4566606750c4915cd33b4eea.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&precrop=1199,1198,x0,y0,safe&width=720",
  priceDollars: 16,
  msrpDollars: 32,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_apparel-baby"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
